/**
 * When this browser tab's session began.
 *
 * Set once at boot and kept in sessionStorage, so a page that reports
 * "what happened while the seller was here" can tell a publication that
 * finished a week ago from one that finished a minute ago in this tab.
 */
const KEY = 'designdeck:session-start';

export function markSessionStart(): void {
  try {
    if (!window.sessionStorage.getItem(KEY)) {
      window.sessionStorage.setItem(KEY, String(Date.now()));
    }
  } catch {
    // Storage may be unavailable in the embed; callers treat null as unknown.
  }
}

export function getSessionStart(): number | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    const value = raw ? Number(raw) : NaN;
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}
